import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const subscriptionsRenewalTrendWidget: DashboardWidgetConfiguration = {
  widgetId: "subscriptions.renewal-trend",
  name: "Renewal activity",
  description: "Renewal activity across the selected period.",
  apps: [
    "subscriptions",
  ],
  template: "graph",
  query: {
    kind: "graph",
    valueQuery: {
      version: 1,
      source: "subscriptions.renewals",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "count_distinct",
          field: "record_id",
          as: "value",
        },
      ],
    },
    graphQueries: [
      {
        name: "Renewals",
        query: {
          version: 1,
          source: "subscriptions.renewals",
          ...period(30),
          select: [
            {
              type: "field",
              field: "renewal_date",
              bucket: "day",
              as: "day",
            },
            {
              type: "aggregate",
              function: "count_distinct",
              field: "record_id",
              as: "value",
            },
          ],
          group_by: [
            {
              field: "renewal_date",
              bucket: "day",
            },
          ],
          order_by: [
            {
              ref: "day",
              direction: "asc",
            },
          ],
        },
        type: "area",
        color: "#206bc4",
        lineWidth: 2,
        fillOpacity: 0.16,
        valueMultiplier: 1,
      },
    ],
  },
  inputs: {
    title: "Renewal activity",
    valueFormat: "number",
    valueMultiplier: 1,
    graphPadding: true,
    chartHeight: 112,
    curve: "smooth",
  },
  dummyData: {
    value: "18",
    series: [
      18,
      24,
      20,
      32,
      29,
      41,
      48,
    ],
  },
  limits: {
    minWidth: 3,
    maxWidth: 12,
    minHeight: 2,
    maxHeight: 6,
    defaultWidth: 6,
    defaultHeight: 3,
  },
};
